import { inject, reactive, ref, provide, computed} from 'vue';

import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';

export default {
  name: 'Discount',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Card,
    SkeletonLoader,
  },
  setup(props) {
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['650w']) return state.item.images['650w'];
        return state.item.images.full;
      }),
      hasAccess: computed(() => {
        let access = false;
        if(state.member && state.item) {
          for(let i = 0; i < state.member.subscriptions.length; i++) {
            for(let k = 0; k < state.member.subscriptions[i].products.length; k++) {
              if(state.item.tiers.includes(state.member.subscriptions[i].products[k].tier) && (state.member.subscriptions[i].status === 'active' || state.member.subscriptions[i].status === 'past_due')) {
                access = true;
                break;
              }
            }
          }
        }
        return access;
      }),
    });

    return {
      state,
      FormattingService,
    }
  }
}
